import { styled } from 'stitches.config'
import { Proteins } from 'models/Pet'

export const RecipeSelectionRoot = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  margin: 'auto',
  marginTop: '$2',
  marginBottom: 0,
  flexWrap: 'wrap',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '300px',

  '@bp3': {
    marginTop: '$7',
    marginBottom: '$4',
    maxWidth: '540px',
  },
})

export const RecipeWrapper = styled('div', {
  width: '40%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '$2',

  '@mobile': {
    width: '32%',
  },

  '@bp3': {
    width: '16%',
    marginBottom: 0,
  }
})

export const RecipeIcon = styled('div', {
  borderRadius: '100%',
  width: '72px',
  height: '72px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out, filter 0.2s ease-in-out',
  filter: 'brightness(1)',

  '& svg': {
    size: '60px',
  },

  '@bp3': {
    width: '60px',
    height: '60px',

    '& svg': {
      size: '48px',
    },
  },

  variants: {
    variant: {
      [Proteins.CHICKEN]: {
        background: '$quaternary-210',
        '&:hover, &:focus': {
          filter: 'brightness(1.1)',
        },
      },
      [Proteins.BEEF]: {
        background: '$primary-500',
        '&:hover, &:focus': {
          filter: 'brightness(1.1)',
        },
      },
      [Proteins.LAMB]: {
        background: '$quaternary-510',
        '&:hover, &:focus': {
          filter: 'brightness(1.1)',
        },
      },
      [Proteins.TURKEY]: {
        background: '$accent-black',
        '&:hover, &:focus': {
          background: '$accent-black',
        },
      },
      [Proteins.VENISON]: {
        background: '$quaternary-610',
        '&:hover, &:focus': {
          filter: 'brightness(1.1)',
        },
      },
      [Proteins.DUCK]: {
        background: '$quaternary-310',
        '&:hover, &:focus': {
          filter: 'brightness(1.1)',
        },
      },
    },
  },
})

export const Highlight = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderStyle: 'solid',
  borderColor: '$primary-500',
  borderWidth: '3px',
  borderRadius: '100%',

  '& div': {
    heigth: '69px',
    width: '69px',
  },

  '@bp3': {
    '& div': {
      width: '57px',
      height: '57px',
    },
  },
})
